import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3Wide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconColumns3Wide"><Path d="M7.58984 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75C2 4.7835 2.7835 4 3.75 4H7.58984V20Z" fill="currentColor"/><Path d="M14.9102 20H9.08984V4H14.9102V20Z" fill="currentColor"/><Path d="M20.25 4C21.2165 4 22 4.7835 22 5.75V18.25C22 19.2165 21.2165 20 20.25 20H16.4102V4H20.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3Wide;
